import { useParams } from "react-router-dom";
import { useDebounceValue, useStateWithSearchParams } from "../../../hooks";
import {
  useGeneratePlaybooksCSVForCampaignMutation,
  useGetAccountsForPlaybooksQuery,
} from "../../../api";
import { ExportCSVModal } from "./ExportCSVModal";
import { useMemo } from "react";

type SearchParams = {
  sizes?: string;
  industries?: string;
  regions?: string;
  search?: string;
  sort?: string;
  page?: string;
  per_page?: string;
  selected?: string;
  limit?: string;
  date?: string;
};

export const ExportPlaybooksFromCampaignModal = ({
  onClose,
}: {
  onClose: () => void;
}) => {
  const { campaign_id } = useParams();

  const { searchDict } = useStateWithSearchParams<SearchParams>({
    search: undefined,
  });

  const querySearchValueDebounce = useDebounceValue(searchDict.search || "");

  const [getPlaybooksCSV, { isLoading: isGenerationCSV }] =
    useGeneratePlaybooksCSVForCampaignMutation();

  const { data: companyList, isLoading } = useGetAccountsForPlaybooksQuery(
    {
      campaign_id: campaign_id!,
      search: querySearchValueDebounce || undefined,
      include_all: true,
    },
    { refetchOnMountOrArgChange: true },
  );

  const submitHandler = (
    account_ids: string[],
    fileName: string,
    isSelectedAll: boolean,
  ) => {
    return getPlaybooksCSV({
      campaign_id: campaign_id!,
      account_ids,
      file_name: fileName.trim(),
      all_accounts: isSelectedAll,
    }).unwrap();
  };

  const items = useMemo(
    () =>
      (companyList?.items || [])?.map((company) => ({
        ...company,
        is_analyzed: true,
      })),
    [companyList],
  );

  return (
    <ExportCSVModal
      title={"Export Playbook Links to CSV"}
      description={
        "For which accounts would you like to export BDR engagement playbook links?"
      }
      items={items}
      isLoading={isGenerationCSV || isLoading}
      onSubmit={submitHandler}
      onClose={onClose}
      submitBtnText={"Export Links"}
    />
  );
};
